<script setup lang="ts">
import switchOff from '@/assets/svgs/switch_off.svg'
import switchOn from '@/assets/svgs/switch_on.svg'
import BaseLayout from '@/components/base/BaseLayout.vue'
import { useIsMobile } from '@/composables/useMediaQuery'
import { useToast } from '@/composables/useToast'
import { useAuthStore } from '@/stores/auth'

const isMobile = useIsMobile()
const authStore = useAuthStore()
const toast = useToast()

const handleSwitchState = (value: boolean) => {
  authStore.updateSubscribedAds(value)
  const date = new Date()
  const formattedDate = date.toLocaleDateString('ko-KR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })

  let message = ''

  if (value) {
    message = `${formattedDate} 광고 수신에 동의하셨습니다.\n수신 동의 철회 : 광고성 정보 수신 설정 off`
  } else {
    message = `${formattedDate} 광고 수신에 거부하셨습니다.\n수신 동의 : 광고성 정보 수신 설정 on`
  }

  toast.showToast(message, 'success')
}
</script>

<template>
  <BaseLayout>
    <div class="my-ads-view">
      <div class="my-ads-view-title title-md white" :class="{ 'title-sm': isMobile }">
        광고성 정보 수신 설정
      </div>
      <div class="my-ads-view-content">
        <div class="my-ads-view-content-info">
          <div class="my-ads-view-content-info-title body-lg white">
            E-mail 및 SMS 광고성 정보 수신
          </div>
          <div class="my-ads-view-content-info-description body-sm gray-600">
            새로운 강좌와 요금 할인 혜택 등 다양한 혜택과 정보를 보내드립니다.
          </div>
        </div>
        <div
          class="my-ads-view-content-toggle-switch cursor-pointer"
          @click="handleSwitchState(!authStore.state.account?.subscribedAds)"
        >
          <img
            :src="authStore.state.account?.subscribedAds ? switchOn : switchOff"
            alt="toggle-on"
          />
        </div>
      </div>
    </div>
  </BaseLayout>
</template>

<style scoped>
.my-ads-view {
  max-width: 418px;
  margin: 0 auto;
}

.my-ads-view-title {
  margin-bottom: 32px;
}

.my-ads-view-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.my-ads-view-content-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

@media (max-width: 1365px) {
  .my-ads-view {
    max-width: 600px;
  }

  .my-ads-view-title {
    padding: 16px 20px;
    margin-bottom: 12px;
  }

  .my-ads-view-content {
    padding: 0 20px;
  }
}
</style>
